import magnificPopup from 'magnific-popup';

$( function() {
    videoPopup();
  
});

function videoPopup() {
    $('.text-with-video .video-popup').magnificPopup({
        type: 'iframe',
        iframe: {
            patterns: {
                vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: 'https://player.vimeo.com/video/%id%?autoplay=1&dnt=1'
                }
            }
        },
        callbacks: {
            open: function() {
                $('.mfp-close').text($('.mfp-close text').text() + ' Close X');
            }
        }
    });
}

